// Internationalization utilities for English/French/Spanish support
export type Language = 'en' | 'fr' | 'es';

export const translations = {
  en: {
    // Navigation
    'nav.tommy': 'TOMMY ROCA',
    'nav.actor': 'ACTOR',
    'nav.model': 'MODEL', 
    'nav.extra': 'EXTRA',
    'nav.talent': 'TALENT & GUEST',
    'nav.create': 'CREATE YOUR HERO',
    
    // Hero Section - CV
    'cv.title': 'TOMMY ROCA',
    'cv.subtitle': 'DECKHAND - WATERSPORT',
    'cv.location': 'Antibes, France',
    'cv.nationality': 'French',
    'cv.dob': '23 October 1981',
    'cv.intro': 'Welcome to Tommy Roca\'s professional maritime portfolio. Discover a unique blend of film industry experience, luxury hospitality expertise, and passionate dedication to the sea. This showcase presents Tommy\'s journey from action film sets to yacht decks, highlighting maritime certifications, water sports mastery, and multicultural service excellence.',
    
    // Personal Story
    'story.title': 'Happy by the Sea, Action by Nature',
    'story.p1': 'Meet Tommy Roca: part action-man, part hospitality expert, and 100% in love with the sea. With a background in the film industry—yes, from the adrenaline of Star Wars to the thrill of Avengers—I\'ve always thrived on a bit of action. But my true calling is the ocean.',
    'story.p2': 'Growing up, I found my happiest moments on islands, learning to swim on Spanish coasts and meditating by the waves. This love of the water led me into hospitality, where I\'ve spent over 20 years delivering top-notch service.',
    'story.p3': 'Now, I\'m channelling all of that experience into the world of water sports. I\'m currently completing my deckhand in Antibes @seascope and looking for a location to complete my training as water sports instructor training—think Jet Ski, Flyboard, E-Foils and I\'m eager to learn every new activity the sea has to offer.',
    'story.p4': 'For me, it\'s not just about one sport—it\'s about becoming a versatile water sports specialist. I\'m a hard worker who loves learning new skills, and I see every new training as a chance to expand my horizons. So, whether I\'m on a six-month contract at sea or spending my downtime exploring new water sports, I\'m always pushing myself to grow.',
    'story.p5': 'My specialty is water sports, and my mission is to bring that passion and energy to every crew and guest I meet.',
    
    // Marine Training
    'marine.title': 'Marine Training 2025',
    'marine.stcw': 'STCW Basic Safety Training',
    'marine.powerboat': 'RYA Powerboat Level 2',
    'marine.pwc': 'RYA Personal Watercraft (PWC)',
    'marine.deckhand': 'Yacht Deckhand Course',
    'marine.medical': 'ENG1 Medical Certificate',
    'marine.provider.seascope': 'Seascope 2025, Antibes',
    'marine.provider.jetski': 'Jet Ski License',
    'marine.provider.mca': 'MCA Approved',
    'marine.valid': 'Valid until Sept 2027',
    
    // Experience
    'exp.title': 'Professional Experience',
    'exp.role1': 'Manager @thegatevr',
    'exp.company1': 'Virtual Game Shop, Paris',
    'exp.desc1': 'Ran daily operations and guest interactions in a tech-driven space. Developed leadership and troubleshooting skills transferable to yachts.',
    'exp.role2': 'Operations & Guest Service',
    'exp.company2': 'Mallorca, Spain',
    'exp.desc2': 'Managed barista, bar, and guest services for international clientele. Adapted quickly to seasonal demand in high-pressure environments.',
    'exp.role3': 'Manager',
    'exp.company3': 'Thames River Boat Cruise, London',
    'exp.desc3': 'Delivered guest services and safety on board a passenger vessel. Anticipated VIP needs and oversaw onboard F&B operations.',
    'exp.role4': 'Assistant Manager',
    'exp.company4': 'Sofitel Club, Australia',
    'exp.desc4': 'Delivered luxury service to VIP guests in a 5-star environment. Supervised multicultural teams while maintaining high standards.',
    'exp.role5': 'Luxury Hospitality & Restaurants',
    'exp.company5': 'International',
    'exp.desc5': '20+ years of VIP service in fine dining, hotels, and luxury venues. Specialised in guest relations, silver service, and adaptability.',
    'exp.role6': 'Film & Entertainment Industry',
    'exp.company6': 'International',
    'exp.desc6': 'Credits include Stormtrooper – Star Wars and Officer – Avengers: Age of Ultron (IMDB). Built discipline, teamwork, and creativity on international productions.',
    
    // Skills
    'skills.title': 'Key Skills',
    'skills.deckhand': 'Deckhand Foundations',
    'skills.watersports': 'Watersports',
    'skills.hospitality': 'Hospitality Excellence',
    'skills.leadership': 'Leadership',
    'skills.safety': 'Safety Awareness',
    'skills.deckhand.1': 'Line handling, knots, mooring',
    'skills.deckhand.2': 'Deck maintenance, washdowns',
    'skills.deckhand.3': 'Maritime safety protocols',
    'skills.watersports.1': 'Jet Ski, SUP, snorkel',
    'skills.watersports.2': 'Progressing toward Flyboard & E-Foil instructor',
    'skills.watersports.3': 'Water sports instruction and safety',
    'skills.hospitality.1': 'Silver service, VIP guest care',
    'skills.hospitality.2': 'Multicultural service',
    'skills.hospitality.3': 'Guest relations expertise',
    'skills.leadership.1': 'Team supervision, adaptability',
    'skills.leadership.2': 'Calm under pressure',
    'skills.leadership.3': 'International team management',
    'skills.safety.1': 'STCW drills (fire, survival, first aid)',
    'skills.safety.2': 'Sea safety protocols',
    'skills.safety.3': 'Emergency response training',

    // Interests
    "interests.title": "Passions & Interests",
    "interests.1": "Advanced watersports & sailing",
    "interests.2": "Extreme sports & physical training", 
    "interests.3": "International travel & culture",
    "interests.4": "Technology & AI innovation",
    "interests.5": "Photography & visual arts",
    "interests.6": "Music production & performance",

    // ROCA Connect - Mentor Marketplace
    "mentor.title": "ROCA Connect Mentors",
    "mentor.subtitle": "Connect with verified experts who understand neurodivergent minds.",
    "mentor.free": "First 15 minutes FREE",
    "mentor.search": "Search mentors...",
    "mentor.allSpecialties": "All Specialties",
    "mentor.allLanguages": "All Languages",
    "mentor.availableNow": "Available Now",
    "mentor.mentorsFound": "mentors found",
    "mentor.sessions": "sessions",
    "mentor.watchIntro": "Watch Intro",
    "mentor.bookSession": "Book Session",
    "mentor.noMatch": "No mentors match your criteria",
    "mentor.clearFilters": "Clear Filters",
    "mentor.dontSeeRight": "Don't see the right mentor?",
    "mentor.chatCTA": "Chat with Captain ROCA AI for FREE 24/7 career guidance, or join our waitlist for specialized mentors.",
    "mentor.chatButton": "Chat with Captain ROCA AI",
    "mentor.waitlistButton": "Join Mentor Waitlist",

    // ROCA Connect - Booking
    "booking.title": "Book Session with",
    "booking.subtitle": "Complete the steps below to schedule your session",
    "booking.step1Title": "1. Choose Session Type",
    "booking.step2Title": "2. Select Date & Time",
    "booking.step3Title": "3. Set Your Goals",
    "booking.step4Title": "4. Confirm Booking",
    "booking.selectDate": "Select Date",
    "booking.selectTime": "Select Time (GMT)",
    "booking.tipMessage": "💡 Tip: Book sessions during your peak focus hours for the best experience!",
    "booking.goalsPrompt": "What do you want to achieve in this session? (At least 1 goal required)",
    "booking.goal": "Goal",
    "booking.required": "(Required)",
    "booking.goalPlaceholder1": "Understand STCW certification requirements",
    "booking.goalPlaceholder2": "Get feedback on my maritime CV",
    "booking.goalPlaceholder3": "Learn about yacht crew job opportunities",
    "booking.sessionDetails": "Session Details",
    "booking.mentor": "Mentor",
    "booking.sessionType": "Session Type",
    "booking.duration": "Duration",
    "booking.date": "Date",
    "booking.time": "Time",
    "booking.yourGoals": "Your Goals",
    "booking.costBreakdown": "Cost Breakdown",
    "booking.firstMinsFree": "First 15 minutes",
    "booking.free": "FREE",
    "booking.remaining": "Remaining",
    "booking.minutes": "minutes",
    "booking.estimatedTotal": "Estimated Total",
    "booking.finalCostNote": "* Final cost based on actual session duration",
    "booking.back": "Back",
    "booking.next": "Next",
    "booking.confirmBook": "Confirm & Book",
    "booking.booking": "Booking...",
    "booking.authRequired": "Authentication required",
    "booking.signInPrompt": "Please sign in to book a session",
    "booking.bookingSuccess": "Session Booked! 🎉",
    "booking.confirmationEmail": "Check your email for confirmation and meeting link",
    "booking.bookingFailed": "Booking failed",
    "booking.tryAgain": "Please try again or contact support",
    "booking.mentorNotFound": "Mentor Not Found",
    "booking.mentorNotFoundDesc": "The requested mentor could not be found.",
    "booking.backToMarketplace": "Back to Marketplace",

    // Session Types
    "session.careerCoaching": "Career Coaching",
    "session.careerCoachingDesc": "Comprehensive career guidance and strategic planning",
    "session.cvReview": "CV Review",
    "session.cvReviewDesc": "Professional CV optimization and feedback",
    "session.certificationGuidance": "Certification Guidance",
    "session.certificationGuidanceDesc": "Step-by-step help with certifications (STCW, etc.)",
    "session.quickQA": "Quick Q&A",
    "session.quickQADesc": "Fast answers to specific questions",

    // Permis Bateau Objectives (French Maritime License)
    "permis.objective1": "Objective 1: Ensure Individual Safety",
    "permis.objective1.desc": "Choose appropriate life jackets, fit them correctly, check their condition",
    "permis.objective2": "Objective 2: Ensure Collective Safety",
    "permis.objective2.desc": "Use safety equipment: life buoys, pumps, fire extinguishers, first aid",
    "permis.objective3": "Objective 3: Communication Equipment",
    "permis.objective3.desc": "Use VHF radio, understand limitations of mobile phones at sea",
    "permis.objective4": "Objective 4: Weather Decision Making",
    "permis.objective4.desc": "Read weather bulletins and decide if it's safe to go out",
    "permis.objective5": "Objective 5: Navigation Rules & Markers",
    "permis.objective5.desc": "Recognize buoys, identify hazards, plan safe routes",
    "permis.objective6": "Objective 6: Captain's Responsibilities",
    "permis.objective6.desc": "Understand legal obligations and common navigation violations",
    "permis.objective7": "Objective 7: Distress Procedures",
    "permis.objective7.desc": "Know when and how to call for help, understand rescue services",
    "permis.objective8": "Objective 8: Environmental Respect",
    "permis.objective8.desc": "Identify pollution sources and practice eco-friendly boating",
    "permis.objective9": "Objective 9: Engine Starting",
    "permis.objective9.desc": "Check engine points, verify levels, start safely",
    "permis.objective10": "Objective 10: Steering Control",
    "permis.objective10.desc": "Maintain straight lines, turn smoothly, follow compass headings",
    "permis.objective11": "Objective 11: Speed Management",
    "permis.objective11.desc": "Accelerate and decelerate safely, read speed instruments",
    "permis.objective12": "Objective 12: Propulsion Control",
    "permis.objective12.desc": "Cut and restore propulsion, stop the boat, reverse safely",
    "permis.objective13": "Objective 13: Reverse Maneuvering",
    "permis.objective13.desc": "Steer in reverse, control speed, back up in a straight line",
    "permis.objective14": "Objective 14: Using Alignments",
    "permis.objective14.desc": "Hold alignment markers for navigation safety",
    "permis.objective15": "Objective 15: Docking Maneuvers",
    "permis.objective15.desc": "Approach and leave quay safely, secure lines properly",
    "permis.objective16": "Objective 16: Mooring Buoys",
    "permis.objective16.desc": "Pick up mooring buoys considering wind and current",
    "permis.objective17": "Objective 17: Anchoring",
    "permis.objective17.desc": "Choose anchorage, deploy anchor safely, check holding",
    "permis.objective18": "Objective 18: Man Overboard Recovery",
    "permis.objective18.desc": "Alert crew, approach casualty safely, recover person from water",

    // Credits
    "credits.acting": "Professional Acting Credits",
    "credits.commercial": "Commercial Work",
    "credits.film": "Film",
    "credits.tv": "TV",
    
    // Education
    'edu.title': 'Education & Training',
    'edu.degree1': 'BTS – Events & Communication',
    'edu.institution1': 'France',
    'edu.degree2': 'Bachelor – Restaurant Management',
    'edu.institution2': 'France',
    'edu.degree3': 'London EBS Bartender',
    'edu.institution3': 'London',
    'edu.details3': 'Bar set-up, inventory, fast service',
    'edu.degree4': 'London EBS Barista',
    'edu.institution4': 'London',
    'edu.details4': 'Brewing methods, basic latte art',
    'edu.degree5': 'Acting & Salsa Workshops',
    'edu.institution5': 'Various',
    'edu.details5': 'Character Work, Dance Expression',
    
    // Interests
    
    // Contact
    'contact.title': 'Get in Touch',
    'contact.email': 'tommyroca.paris@gmail.com',
    'contact.phone': '+33 7 497 11 500',
    'contact.imdb': 'IMDB Credits: Star Wars & Avengers',
    
    // Languages
    'lang.french': 'French',
    'lang.english': 'English',
    'lang.spanish': 'Spanish',
    
    // Professional Details
    'profile.details': 'Professional Details',
    'profile.height': 'Height',
    'profile.playingAge': 'Playing Age',
    'profile.measurements': 'Measurements',
    'profile.weight': 'Weight',
    'profile.eyes': 'Eyes / Hair',
    'profile.location': 'Location',
    'profile.contact': 'Contact & Links',
    'profile.imdb': 'IMDb Profile',
    
    // Video Reels
    'reels.title': 'Action Reels',
    'reels.subtitle': 'AI Generated Characters + Real Footage',
    'reels.aiGenerated': 'AI Generated',
    'reels.realFootage': 'Real Footage',
    
    
    // AI Characters
    'ai.title': 'The World of Infinite Possibilities',
    'ai.subtitle': 'Explore Tommy\'s AI-generated character universe',
    'ai.description': 'From cyberpunk agents to medieval warriors, witness the future of character creation',
    
    // Downloads
    'downloads.title': 'Professional Downloads',
    'downloads.cv': 'Download CV',
    'downloads.headshots': 'Download Headshots',
    'downloads.showreel': 'Download Showreel',
    
    // Booking Tommy (Production)
    'bookingTommy.title': 'Book Tommy Roca',
    'bookingTommy.name': 'Your Name *',
    'bookingTommy.email': 'Email *',
    'bookingTommy.company': 'Company/Production',
    'bookingTommy.role': 'Role/Character',
    'bookingTommy.description': 'Project Description *',
    'bookingTommy.budget': 'Budget Range',
    'bookingTommy.timeline': 'Timeline/Shoot Dates',
    'bookingTommy.submit': 'Send Booking Request',
    'bookingTommy.success': 'Booking request sent successfully! Tommy will contact you within 24 hours.',
    'bookingTommy.error': 'Failed to send booking request. Please try again.',
    
    
    // ROCA Writer
    "writer.title": "ROCA Writer",
    "writer.subtitle": "Spell-check & Tone Adjuster for Dyslexic Minds",
    "writer.inputLabel": "Your Text",
    "writer.inputPlaceholder": "Paste or type your text here...",
    "writer.selectTone": "Select tone/context",
    "writer.correctAndAdapt": "Correct & Adapt",
    "writer.processing": "Processing...",
    "writer.correctedText": "Corrected Text",
    "writer.adaptedText": "Adapted Text",
    "writer.noText": "Please enter some text",
    "writer.noErrors": "No errors found! ✓",
    "writer.errorsFound": "errors found",
    "writer.copied": "Copied to clipboard!",
    "writer.correctionComplete": "Correction complete!",
    "writer.error": "An error occurred. Please try again.",

    // Tone contexts
    "tone.professional": "Professional",
    "tone.friendly": "Friendly",
    "tone.formal": "Formal",
    "tone.interview": "Job Interview",
    "tone.followup": "Follow-up",
    "tone.boss": "Talking to Boss",
    "tone.family": "Family",
    "tone.romantic": "Romantic",
    "tone.firstDate": "First Date",
    "tone.castingDirector": "Casting Director",
    "tone.yachtCaptain": "Yacht Captain",
    "tone.maritimeInstructor": "Maritime Instructor",
    "tone.examAnswer": "Exam Answer",

    // Common
    'close': 'Close',
    'download': 'Download',
    'view': 'View',
    'share': 'Share',
    'loading': 'Loading...',
  },
  fr: {
    // Navigation
    'nav.tommy': 'TOMMY ROCA',
    'nav.actor': 'ACTEUR',
    'nav.model': 'MANNEQUIN',
    'nav.extra': 'FIGURANT',
    'nav.talent': 'TALENT & INVITÉ',
    'nav.create': 'CRÉEZ VOTRE HÉROS',
    'nav.rocaConnect': 'ROCA CONNECT',
    
    // Hero Section - CV
    'cv.title': 'TOMMY ROCA',
    'cv.subtitle': 'MATELOT DE PONT - SPORTS NAUTIQUES',
    'cv.location': 'Antibes, France',
    'cv.nationality': 'Français',
    'cv.dob': '23 octobre 1981',
    'cv.intro': 'Bienvenue dans le portfolio maritime professionnel de Tommy Roca. Découvrez un mélange unique d\'expérience dans l\'industrie cinématographique, d\'expertise en hôtellerie de luxe et de dévouement passionné à la mer. Cette vitrine présente le parcours de Tommy des plateaux de cinéma d\'action aux ponts de yachts, mettant en évidence les certifications maritimes, la maîtrise des sports nautiques et l\'excellence du service multiculturel.',
    
    // Personal Story
    'story.title': 'Heureux près de la mer, action par nature',
    'story.p1': 'Rencontrez Tommy Roca : à la fois homme d\'action, expert en hôtellerie, et 100% amoureux de la mer. Avec un background dans l\'industrie du cinéma—oui, de l\'adrénaline de Star Wars au frisson des Avengers—j\'ai toujours prospéré avec un peu d\'action. Mais ma vraie vocation, c\'est l\'océan.',
    'story.p2': 'En grandissant, j\'ai trouvé mes moments les plus heureux sur les îles, apprenant à nager sur les côtes espagnoles et méditant près des vagues. Cet amour de l\'eau m\'a mené vers l\'hôtellerie, où j\'ai passé plus de 20 ans à fournir un service de premier plan.',
    'story.p3': 'Maintenant, je canalise toute cette expérience dans le monde des sports nautiques. Je suis actuellement en train de terminer ma formation de matelot de pont à Antibes @seascope et je cherche un endroit pour compléter ma formation d\'instructeur de sports nautiques—pensez Jet Ski, Flyboard, E-Foils et j\'ai hâte d\'apprendre chaque nouvelle activité que la mer a à offrir.',
    'story.p4': 'Pour moi, il ne s\'agit pas seulement d\'un sport—il s\'agit de devenir un spécialiste polyvalent des sports nautiques. Je suis un travailleur acharné qui aime apprendre de nouvelles compétences, et je vois chaque nouvelle formation comme une chance d\'élargir mes horizons. Donc, que je sois sur un contrat de six mois en mer ou que je passe mon temps libre à explorer de nouveaux sports nautiques, je me pousse toujours à grandir.',
    'story.p5': 'Ma spécialité, ce sont les sports nautiques, et ma mission est d\'apporter cette passion et cette énergie à chaque équipage et invité que je rencontre.',
    
    // Marine Training
    'marine.title': 'Formation Maritime 2025',
    'marine.stcw': 'Formation de Base STCW',
    'marine.powerboat': 'RYA Bateau à Moteur Niveau 2',
    'marine.pwc': 'RYA Véhicule Nautique Personnel (PWC)',
    'marine.deckhand': 'Cours de Matelot de Pont Yacht',
    'marine.medical': 'Certificat Médical ENG1',
    'marine.provider.seascope': 'Seascope 2025, Antibes',
    'marine.provider.jetski': 'Licence Jet Ski',
    'marine.provider.mca': 'Approuvé MCA',
    'marine.valid': 'Valide jusqu\'en septembre 2027',
    
    // Experience
    'exp.title': 'Expérience Professionnelle',
    'exp.role1': 'Manager @thegatevr',
    'exp.company1': 'Boutique de Jeux Virtuels, Paris',
    'exp.desc1': 'A dirigé les opérations quotidiennes et les interactions avec les invités dans un espace technologique. Développé des compétences de leadership et de dépannage transférables aux yachts.',
    'exp.role2': 'Opérations & Service Client',
    'exp.company2': 'Majorque, Espagne',
    'exp.desc2': 'Géré barista, bar et services clients pour une clientèle internationale. Adapté rapidement à la demande saisonnière dans des environnements haute pression.',
    'exp.role3': 'Manager',
    'exp.company3': 'Croisière sur la Tamise, Londres',
    'exp.desc3': 'Fourni services clients et sécurité à bord d\'un navire à passagers. Anticipé les besoins VIP et supervisé les opérations F&B à bord.',
    'exp.role4': 'Manager Adjoint',
    'exp.company4': 'Sofitel Club, Australie',
    'exp.desc4': 'Fourni service de luxe aux invités VIP dans un environnement 5 étoiles. Supervisé des équipes multiculturelles tout en maintenant des standards élevés.',
    'exp.role5': 'Hôtellerie de Luxe & Restaurants',
    'exp.company5': 'International',
    'exp.desc5': '20+ années de service VIP dans la restauration fine, les hôtels et les lieux de luxe. Spécialisé dans les relations clients, le service à l\'argenterie et l\'adaptabilité.',
    'exp.role6': 'Industrie du Cinéma & Divertissement',
    'exp.company6': 'International',
    'exp.desc6': 'Crédits incluent Stormtrooper – Star Wars et Officier – Avengers: Age of Ultron (IMDB). Construit discipline, travail d\'équipe et créativité sur des productions internationales.',
    
    // Skills
    'skills.title': 'Compétences Clés',
    'skills.deckhand': 'Fondations Matelot de Pont',
    'skills.watersports': 'Sports Nautiques',
    'skills.hospitality': 'Excellence Hôtelière',
    'skills.leadership': 'Leadership',
    'skills.safety': 'Conscience Sécuritaire',
    'skills.deckhand.1': 'Manipulation des cordes, nœuds, amarrage',
    'skills.deckhand.2': 'Entretien du pont, lavages',
    'skills.deckhand.3': 'Protocoles de sécurité maritime',
    'skills.watersports.1': 'Jet Ski, SUP, plongée avec tuba',
    'skills.watersports.2': 'Progression vers instructeur Flyboard & E-Foil',
    'skills.watersports.3': 'Instruction et sécurité sports nautiques',
    'skills.hospitality.1': 'Service à l\'argenterie, soins invités VIP',
    'skills.hospitality.2': 'Service multiculturel',
    'skills.hospitality.3': 'Expertise relations clients',
    'skills.leadership.1': 'Supervision d\'équipe, adaptabilité',
    'skills.leadership.2': 'Calme sous pression',
    'skills.leadership.3': 'Gestion d\'équipe internationale',
    'skills.safety.1': 'Exercices STCW (incendie, survie, premiers secours)',
    'skills.safety.2': 'Protocoles de sécurité en mer',
    'skills.safety.3': 'Formation réponse d\'urgence',

    // Interests
    "interests.title": "Passions & Intérêts",
    "interests.1": "Sports nautiques avancés & voile",
    "interests.2": "Sports extrêmes & entraînement physique",
    "interests.3": "Voyages internationaux & culture", 
    "interests.4": "Technologie & innovation IA",
    "interests.5": "Photographie & arts visuels",
    "interests.6": "Production musicale & performance",

    // Credits
    "credits.acting": "Crédits d'Acteur Professionnel",
    "credits.commercial": "Travail Commercial",
    "credits.film": "Film",
    "credits.tv": "TV",
    
    // Education
    'edu.title': 'Éducation & Formation',
    'edu.degree1': 'BTS – Événementiel & Communication',
    'edu.institution1': 'France',
    'edu.degree2': 'Licence – Gestion de Restaurant',
    'edu.institution2': 'France',
    'edu.degree3': 'London EBS Barman',
    'edu.institution3': 'Londres',
    'edu.details3': 'Installation de bar, inventaire, service rapide',
    'edu.degree4': 'London EBS Barista',
    'edu.institution4': 'Londres',
    'edu.details4': 'Méthodes d\'infusion, art latte de base',
    'edu.degree5': 'Ateliers Théâtre & Salsa',
    'edu.institution5': 'Divers',
    'edu.details5': 'Travail de Personnage, Expression Danse',
    
    // ROCA Connect - Mentor Marketplace
    "mentor.title": "Trouvez Votre Mentor Idéal",
    "mentor.subtitle": "Connectez-vous avec des professionnels expérimentés qui comprennent votre parcours.",
    "mentor.free": "15 premières minutes gratuites",
    "mentor.search": "Rechercher des mentors par nom ou expertise...",
    "mentor.allSpecialties": "Toutes les Spécialités",
    "mentor.allLanguages": "Toutes les Langues",
    "mentor.availableNow": "Disponible Maintenant",
    "mentor.mentorsFound": "mentors trouvés",
    "mentor.noMatch": "Aucun mentor ne correspond à vos critères",
    "mentor.clearFilters": "Effacer les Filtres",
    "mentor.watchIntro": "Voir l'Intro",
    "mentor.bookSession": "Réserver une Session",
    "mentor.dontSeeRight": "Vous ne trouvez pas le bon mentor ?",
    "mentor.chatCTA": "Discutez avec Captain ROCA AI pour obtenir des recommandations personnalisées ou rejoignez notre liste d'attente pour être averti lorsque de nouveaux mentors rejoignent.",
    "mentor.chatButton": "Discuter avec Captain ROCA",
    "mentor.waitlistButton": "Rejoindre la Liste d'Attente",
    "mentor.availableNowBadge": "Disponible Maintenant",
    "mentor.dyslexiaFriendly": "Adapté Dyslexie",
    "mentor.neurodiversityTrained": "Formé Neurodiversité",
    "mentor.defaultBio": "Mentor expérimenté prêt à vous aider à atteindre vos objectifs.",
    "mentor.perHour": "/heure",

    // Specialty names
    "specialty.maritime": "Maritime",
    "specialty.film": "Cinéma & Divertissement",
    "specialty.dyslexiaCoaching": "Accompagnement Dyslexie",
    "specialty.adhdSupport": "Soutien TDAH",

    // ROCA Connect - Booking
    "booking.title": "Réserver une Session avec",
    "booking.subtitle": "Complétez les étapes ci-dessous pour planifier votre session",
    "booking.step1Title": "1. Choisir le Type de Session",
    "booking.step2Title": "2. Sélectionner Date & Heure",
    "booking.step3Title": "3. Définir Vos Objectifs",
    "booking.step4Title": "4. Confirmer la Réservation",
    "booking.selectDate": "Sélectionner la Date",
    "booking.selectTime": "Sélectionner l'Heure (GMT)",
    "booking.tipMessage": "💡 Astuce : Réservez vos sessions pendant vos heures de concentration maximale pour une meilleure expérience !",
    "booking.goalsPrompt": "Que souhaitez-vous accomplir lors de cette session ? (Au moins 1 objectif requis)",
    "booking.goal": "Objectif",
    "booking.required": "(Obligatoire)",
    "booking.goalPlaceholder1": "Comprendre les exigences de la certification STCW",
    "booking.goalPlaceholder2": "Obtenir des retours sur mon CV maritime",
    "booking.goalPlaceholder3": "Découvrir les opportunités d'emploi dans les équipages de yacht",
    "booking.sessionDetails": "Détails de la Session",
    "booking.mentor": "Mentor",
    "booking.sessionType": "Type de Session",
    "booking.duration": "Durée",
    "booking.date": "Date",
    "booking.time": "Heure",
    "booking.yourGoals": "Vos Objectifs",
    "booking.costBreakdown": "Détail des Coûts",
    "booking.firstMinsFree": "15 premières minutes",
    "booking.free": "GRATUIT",
    "booking.remaining": "Restant",
    "booking.minutes": "minutes",
    "booking.estimatedTotal": "Total Estimé",
    "booking.finalCostNote": "* Coût final basé sur la durée réelle de la session",
    "booking.back": "Retour",
    "booking.next": "Suivant",
    "booking.confirmBook": "Confirmer & Réserver",
    "booking.booking": "Réservation en cours...",
    "booking.authRequired": "Authentification requise",
    "booking.signInPrompt": "Veuillez vous connecter pour réserver une session",
    "booking.bookingSuccess": "Session Réservée ! 🎉",
    "booking.confirmationEmail": "Vérifiez votre email pour la confirmation et le lien de réunion",
    "booking.bookingFailed": "Échec de la réservation",
    "booking.tryAgain": "Veuillez réessayer ou contacter le support",
    "booking.mentorNotFound": "Mentor Non Trouvé",
    "booking.mentorNotFoundDesc": "Le mentor demandé n'a pas pu être trouvé.",
    "booking.backToMarketplace": "Retour au Marché",

    // Session Types
    "session.careerCoaching": "Coaching de Carrière",
    "session.careerCoachingDesc": "Orientation professionnelle complète et planification stratégique",
    "session.cvReview": "Révision de CV",
    "session.cvReviewDesc": "Optimisation et retour professionnel sur votre CV",
    "session.certificationGuidance": "Accompagnement Certification",
    "session.certificationGuidanceDesc": "Aide étape par étape pour les certifications (STCW, etc.)",
    "session.quickQA": "Questions Rapides",
    "session.quickQADesc": "Réponses rapides à des questions spécifiques",

    // Objectifs Permis Bateau (Licence Maritime Française)
    "permis.objective1": "Objectif 1: Assurer la Sécurité Individuelle",
    "permis.objective1.desc": "Choisir les gilets de sauvetage appropriés, les ajuster correctement, vérifier leur état",
    "permis.objective2": "Objectif 2: Assurer la Sécurité Collective",
    "permis.objective2.desc": "Utiliser l'équipement de sécurité: bouées, pompes, extincteurs, trousse de secours",
    "permis.objective3": "Objectif 3: Équipement de Communication",
    "permis.objective3.desc": "Utiliser la radio VHF, comprendre les limites des téléphones portables en mer",
    "permis.objective4": "Objectif 4: Décision Météorologique",
    "permis.objective4.desc": "Lire les bulletins météo et décider s'il est sûr de sortir",
    "permis.objective5": "Objectif 5: Règles de Navigation & Balisage",
    "permis.objective5.desc": "Reconnaître les balises, identifier les dangers, planifier des routes sûres",
    "permis.objective6": "Objectif 6: Responsabilités du Capitaine",
    "permis.objective6.desc": "Comprendre les obligations légales et infractions courantes de navigation",
    "permis.objective7": "Objectif 7: Procédures de Détresse",
    "permis.objective7.desc": "Savoir quand et comment appeler à l'aide, comprendre les services de secours",
    "permis.objective8": "Objectif 8: Respect de l'Environnement",
    "permis.objective8.desc": "Identifier les sources de pollution et pratiquer une navigation écologique",
    "permis.objective9": "Objectif 9: Démarrage du Moteur",
    "permis.objective9.desc": "Vérifier les points du moteur, contrôler les niveaux, démarrer en sécurité",
    "permis.objective10": "Objectif 10: Contrôle de la Direction",
    "permis.objective10.desc": "Maintenir des lignes droites, tourner en douceur, suivre les caps au compas",
    "permis.objective11": "Objectif 11: Gestion de la Vitesse",
    "permis.objective11.desc": "Accélérer et décélérer en sécurité, lire les instruments de vitesse",
    "permis.objective12": "Objectif 12: Contrôle de la Propulsion",
    "permis.objective12.desc": "Couper et rétablir la propulsion, arrêter le bateau, faire marche arrière en sécurité",
    "permis.objective13": "Objectif 13: Manœuvre en Marche Arrière",
    "permis.objective13.desc": "Diriger en marche arrière, contrôler la vitesse, reculer en ligne droite",
    "permis.objective14": "Objectif 14: Utilisation des Alignements",
    "permis.objective14.desc": "Tenir les alignements pour la sécurité de navigation",
    "permis.objective15": "Objectif 15: Manœuvres d'Accostage",
    "permis.objective15.desc": "Approcher et quitter un quai en sécurité, sécuriser les amarres correctement",
    "permis.objective16": "Objectif 16: Bouées de Corps-Mort",
    "permis.objective16.desc": "Prendre les bouées d'amarrage en tenant compte du vent et du courant",
    "permis.objective17": "Objectif 17: Mouillage",
    "permis.objective17.desc": "Choisir un mouillage, déployer l'ancre en sécurité, vérifier la tenue",
    "permis.objective18": "Objectif 18: Récupération Homme à la Mer",
    "permis.objective18.desc": "Alerter l'équipage, approcher la victime en sécurité, récupérer la personne de l'eau",
    
    // Contact
    'contact.title': 'Entrer en Contact',
    'contact.email': 'tommyroca.paris@gmail.com',
    'contact.phone': '+33 7 497 11 500',
    'contact.imdb': 'Crédits IMDB : Star Wars & Avengers',
    
    // Languages
    'lang.french': 'Français',
    'lang.english': 'Anglais',
    'lang.spanish': 'Espagnol',
    
    // Professional Details
    'profile.details': 'Détails Professionnels',
    'profile.height': 'Taille',
    'profile.playingAge': 'Âge de Jeu',
    'profile.measurements': 'Mensurations',
    'profile.weight': 'Poids',
    'profile.eyes': 'Yeux / Cheveux',
    'profile.location': 'Localisation',
    'profile.contact': 'Contact & Liens',
    'profile.imdb': 'Profil IMDb',
    
    // Video Reels
    'reels.title': 'Bobines d\'Action',
    'reels.subtitle': 'Personnages Générés par IA + Vraies Images',
    'reels.aiGenerated': 'Généré par IA',
    'reels.realFootage': 'Vraies Images',
    
    
    // AI Characters
    'ai.title': 'Le Monde des Possibilités Infinies',
    'ai.subtitle': 'Explorez l\'univers des personnages générés par IA de Tommy',
    'ai.description': 'Des agents cyberpunk aux guerriers médiévaux, découvrez l\'avenir de la création de personnages',
    
    // Downloads
    'downloads.title': 'Téléchargements Professionnels',
    'downloads.cv': 'Télécharger CV',
    'downloads.headshots': 'Télécharger Photos',
    'downloads.showreel': 'Télécharger Bobine',
    
    // Booking Tommy (Production)
    'bookingTommy.title': 'Réserver Tommy Roca',
    'bookingTommy.name': 'Votre Nom *',
    'bookingTommy.email': 'Email *',
    'bookingTommy.company': 'Société/Production',
    'bookingTommy.role': 'Rôle/Personnage',
    'bookingTommy.description': 'Description du Projet *',
    'bookingTommy.budget': 'Gamme de Budget',
    'bookingTommy.timeline': 'Calendrier/Dates de Tournage',
    'bookingTommy.submit': 'Envoyer Demande de Réservation',
    'bookingTommy.success': 'Demande de réservation envoyée avec succès ! Tommy vous contactera dans les 24 heures.',
    'bookingTommy.error': 'Échec de l\'envoi de la demande de réservation. Veuillez réessayer.',
    
    // ROCA Writer (French)
    "writer.title": "Correcteur ROCA",
    "writer.subtitle": "Orthographe & Adaptation de Ton pour esprits dyslexiques",
    "writer.inputLabel": "Votre Texte",
    "writer.inputPlaceholder": "Collez ou tapez votre texte ici...",
    "writer.selectTone": "Choisir le ton/contexte",
    "writer.correctAndAdapt": "Corriger & Adapter",
    "writer.processing": "Traitement...",
    "writer.correctedText": "Texte Corrigé",
    "writer.adaptedText": "Texte Adapté",
    "writer.noText": "Veuillez entrer du texte",
    "writer.noErrors": "Aucune erreur trouvée ! ✓",
    "writer.errorsFound": "erreurs trouvées",
    "writer.copied": "Copié dans le presse-papiers !",
    "writer.correctionComplete": "Correction terminée !",
    "writer.error": "Une erreur s'est produite. Veuillez réessayer.",

    // Tone contexts (French)
    "tone.professional": "Professionnel",
    "tone.friendly": "Amical",
    "tone.formal": "Formel",
    "tone.interview": "Entretien d'embauche",
    "tone.followup": "Relance",
    "tone.boss": "Parler au chef",
    "tone.family": "Famille",
    "tone.romantic": "Romantique",
    "tone.firstDate": "Premier rendez-vous",
    "tone.castingDirector": "Directeur de casting",
    "tone.yachtCaptain": "Capitaine de yacht",
    "tone.maritimeInstructor": "Instructeur maritime",
    "tone.examAnswer": "Réponse d'examen",
    
    // Common
    'close': 'Fermer',
    'download': 'Télécharger',
    'view': 'Voir',
    'share': 'Partager',
    'loading': 'Chargement...',
  },
  es: {
    // Navigation
    'nav.tommy': 'TOMMY ROCA',
    'nav.actor': 'ACTOR',
    'nav.model': 'MODELO',
    'nav.extra': 'EXTRA',
    'nav.talent': 'TALENTO E INVITADO',
    'nav.create': 'CREA TU HÉROE',
    
    // Hero Section - CV
    'cv.title': 'TOMMY ROCA',
    'cv.subtitle': 'MARINERO DE CUBIERTA - DEPORTES ACUÁTICOS',
    'cv.location': 'Antibes, Francia',
    'cv.nationality': 'Francés',
    'cv.dob': '23 de octubre de 1981',
    'cv.intro': 'Bienvenido al portafolio marítimo profesional de Tommy Roca. Descubre una mezcla única de experiencia en la industria cinematográfica, experiencia en hospitalidad de lujo y dedicación apasionada al mar. Esta vitrina presenta el viaje de Tommy desde sets de películas de acción hasta cubiertas de yates, destacando certificaciones marítimas, dominio de deportes acuáticos y excelencia en servicio multicultural.',
    
    // Personal Story
    'story.title': 'Feliz junto al mar, acción por naturaleza',
    'story.p1': 'Conoce a Tommy Roca: parte hombre de acción, parte experto en hospitalidad, y 100% enamorado del mar. Con experiencia en la industria del cine—sí, desde la adrenalina de Star Wars hasta la emoción de Avengers—siempre he prosperado con un poco de acción. Pero mi verdadera vocación es el océano.',
    'story.p2': 'Creciendo, encontré mis momentos más felices en islas, aprendiendo a nadar en costas españolas y meditando junto a las olas. Este amor por el agua me llevó a la hospitalidad, donde he pasado más de 20 años brindando servicio de primera clase.',
    'story.p3': 'Ahora, estoy canalizando toda esa experiencia hacia el mundo de los deportes acuáticos. Actualmente estoy completando mi marinero de cubierta en Antibes @seascope y buscando una ubicación para completar mi entrenamiento como instructor de deportes acuáticos—piensa en Jet Ski, Flyboard, E-Foils y estoy ansioso por aprender cada nueva actividad que el mar tiene para ofrecer.',
    'story.p4': 'Para mí, no se trata solo de un deporte—se trata de convertirme en un especialista versátil en deportes acuáticos. Soy un trabajador dedicado que ama aprender nuevas habilidades, y veo cada nuevo entrenamiento como una oportunidad para expandir mis horizontes. Entonces, ya sea que esté en un contrato de seis meses en el mar o pasando mi tiempo libre explorando nuevos deportes acuáticos, siempre me estoy empujando a crecer.',
    'story.p5': 'Mi especialidad son los deportes acuáticos, y mi misión es llevar esa pasión y energía a cada tripulación e invitado que conozco.',
    
    // Marine Training
    'marine.title': 'Entrenamiento Marítimo 2025',
    'marine.stcw': 'Entrenamiento Básico de Seguridad STCW',
    'marine.powerboat': 'RYA Lancha Motora Nivel 2',
    'marine.pwc': 'RYA Vehículo Acuático Personal (PWC)',
    'marine.deckhand': 'Curso de Marinero de Cubierta de Yate',
    'marine.medical': 'Certificado Médico ENG1',
    'marine.provider.seascope': 'Seascope 2025, Antibes',
    'marine.provider.jetski': 'Licencia Jet Ski',
    'marine.provider.mca': 'Aprobado MCA',
    'marine.valid': 'Válido hasta septiembre 2027',
    
    // Experience
    'exp.title': 'Experiencia Profesional',
    'exp.role1': 'Manager @thegatevr',
    'exp.company1': 'Tienda de Juegos Virtuales, París',
    'exp.desc1': 'Dirigió operaciones diarias e interacciones con huéspedes en un espacio tecnológico. Desarrolló habilidades de liderazgo y resolución de problemas transferibles a yates.',
    'exp.role2': 'Operaciones y Servicio al Huésped',
    'exp.company2': 'Mallorca, España',
    'exp.desc2': 'Gestionó barista, bar y servicios al huésped para clientela internacional. Se adaptó rápidamente a la demanda estacional en ambientes de alta presión.',
    'exp.role3': 'Manager',
    'exp.company3': 'Crucero del Río Támesis, Londres',
    'exp.desc3': 'Brindó servicios al huésped y seguridad a bordo de una embarcación de pasajeros. Anticipó necesidades VIP y supervisó operaciones F&B a bordo.',
    'exp.role4': 'Manager Asistente',
    'exp.company4': 'Sofitel Club, Australia',
    'exp.desc4': 'Brindó servicio de lujo a huéspedes VIP en un ambiente de 5 estrellas. Supervisó equipos multiculturales mientras mantenía altos estándares.',
    'exp.role5': 'Hospitalidad de Lujo y Restaurantes',
    'exp.company5': 'Internacional',
    'exp.desc5': '20+ años de servicio VIP en gastronomía fina, hoteles y lugares de lujo. Especializado en relaciones con huéspedes, servicio de plata y adaptabilidad.',
    'exp.role6': 'Industria del Cine y Entretenimiento',
    'exp.company6': 'Internacional',
    'exp.desc6': 'Créditos incluyen Stormtrooper – Star Wars y Oficial – Avengers: Age of Ultron (IMDB). Construyó disciplina, trabajo en equipo y creatividad en producciones internacionales.',
    
    // Skills
    'skills.title': 'Habilidades Clave',
    'skills.deckhand': 'Fundamentos de Marinero de Cubierta',
    'skills.watersports': 'Deportes Acuáticos',
    'skills.hospitality': 'Excelencia en Hospitalidad',
    'skills.leadership': 'Liderazgo',
    'skills.safety': 'Conciencia de Seguridad',
    'skills.deckhand.1': 'Manejo de líneas, nudos, amarre',
    'skills.deckhand.2': 'Mantenimiento de cubierta, lavados',
    'skills.deckhand.3': 'Protocolos de seguridad marítima',
    'skills.watersports.1': 'Jet Ski, SUP, snorkel',
    'skills.watersports.2': 'Progresando hacia instructor Flyboard y E-Foil',
    'skills.watersports.3': 'Instrucción y seguridad en deportes acuáticos',
    'skills.hospitality.1': 'Servicio de plata, atención VIP a huéspedes',
    'skills.hospitality.2': 'Servicio multicultural',
    'skills.hospitality.3': 'Experiencia en relaciones con huéspedes',
    'skills.leadership.1': 'Supervisión de equipo, adaptabilidad',
    'skills.leadership.2': 'Tranquilo bajo presión',
    'skills.leadership.3': 'Gestión de equipo internacional',
    'skills.safety.1': 'Ejercicios STCW (incendio, supervivencia, primeros auxilios)',
    'skills.safety.2': 'Protocolos de seguridad en el mar',
    'skills.safety.3': 'Entrenamiento de respuesta de emergencia',
    
    // Education
    'edu.title': 'Educación y Entrenamiento',
    'edu.degree1': 'BTS – Eventos y Comunicación',
    'edu.institution1': 'Francia',
    'edu.degree2': 'Licenciatura – Gestión de Restaurantes',
    'edu.institution2': 'Francia',
    'edu.degree3': 'London EBS Bartender',
    'edu.institution3': 'Londres',
    'edu.details3': 'Configuración de bar, inventario, servicio rápido',
    'edu.degree4': 'London EBS Barista',
    'edu.institution4': 'Londres',
    'edu.details4': 'Métodos de preparación, arte latte básico',
    'edu.degree5': 'Talleres de Actuación y Salsa',
    'edu.institution5': 'Varios',
    'edu.details5': 'Trabajo de Personaje, Expresión de Danza',
    
    // Interests
    'interests.title': 'Intereses y Pasiones',
    'interests.1': 'Deportes Acuáticos Extremos: Jet Ski, Flyboard, E-Foils, Surf',
    'interests.2': 'Viajes y Aventura: Isla Hamilton, Filipinas, Brasil, Tailandia, Ciudad del Cabo, Abiyán, Nueva Zelanda',
    'interests.3': 'Fitness y Bienestar: Natación, Boxeo, Calistenia, Meditación',
    'interests.4': 'Proyectos Creativos: Cine, VR, Narrativa impulsada por IA, Fotografía',
    'interests.5': 'Estilo de vida marítimo y navegación',
    'interests.6': 'Aprendizaje continuo y desarrollo de habilidades',
    
    // Contact
    'contact.title': 'Ponerse en Contacto',
    'contact.email': 'tommyroca.paris@gmail.com',
    'contact.phone': '+33 7 497 11 500',
    'contact.imdb': 'Créditos IMDB: Star Wars y Avengers',
    
    // Languages
    'lang.french': 'Francés',
    'lang.english': 'Inglés',
    'lang.spanish': 'Español',
    
    // Professional Details
    'profile.details': 'Detalles Profesionales',
    'profile.height': 'Altura',
    'profile.playingAge': 'Edad de Actuación',
    'profile.measurements': 'Medidas',
    'profile.weight': 'Peso',
    'profile.eyes': 'Ojos / Cabello',
    'profile.location': 'Ubicación',
    'profile.contact': 'Contacto y Enlaces',
    'profile.imdb': 'Perfil IMDb',
    
    // Video Reels
    'reels.title': 'Carretes de Acción',
    'reels.subtitle': 'Personajes Generados por IA + Metraje Real',
    'reels.aiGenerated': 'Generado por IA',
    'reels.realFootage': 'Metraje Real',
    
    // Acting Credits
    'credits.title': 'Créditos de Actuación e IMDb',
    'credits.film': 'Película',
    'credits.tv': 'Serie de TV',
    'credits.commercial': 'Comercial',
    
    // AI Characters
    'ai.title': 'El Mundo de Posibilidades Infinitas',
    'ai.subtitle': 'Explora el universo de personajes generados por IA de Tommy',
    'ai.description': 'Desde agentes cyberpunk hasta guerreros medievales, presencia el futuro de la creación de personajes',
    
    // Downloads
    'downloads.title': 'Descargas Profesionales',
    'downloads.cv': 'Descargar CV',
    'downloads.headshots': 'Descargar Fotos',
    'downloads.showreel': 'Descargar Carrete',
    
    // Booking
    'booking.title': 'Contratar a Tommy Roca',
    'booking.name': 'Tu Nombre *',
    'booking.email': 'Email *',
    'booking.company': 'Empresa/Producción',
    'booking.role': 'Rol/Personaje',
    'booking.description': 'Descripción del Proyecto *',
    'booking.budget': 'Rango de Presupuesto',
    'booking.timeline': 'Cronograma/Fechas de Rodaje',
    'booking.submit': 'Enviar Solicitud de Contratación',
    'booking.success': '¡Solicitud de contratación enviada exitosamente! Tommy te contactará dentro de 24 horas.',
    'booking.error': 'Error al enviar la solicitud de contratación. Por favor intenta de nuevo.',
    
    // ROCA Connect - Mentor Marketplace
    "mentor.title": "Encuentra Tu Mentor Ideal",
    "mentor.subtitle": "Conéctate con profesionales experimentados que entienden tu camino.",
    "mentor.free": "Primeros 15 minutos GRATIS",
    "mentor.search": "Buscar mentores...",
    "mentor.allSpecialties": "Todas las Especialidades",
    "mentor.allLanguages": "Todos los Idiomas",
    "mentor.availableNow": "Disponible Ahora",
    "mentor.mentorsFound": "mentores encontrados",
    "mentor.sessions": "sesiones",
    "mentor.watchIntro": "Ver Introducción",
    "mentor.bookSession": "Reservar Sesión",
    "mentor.noMatch": "Ningún mentor coincide con tus criterios",
    "mentor.clearFilters": "Limpiar Filtros",
    "mentor.dontSeeRight": "¿No encuentras el mentor adecuado?",
    "mentor.chatCTA": "Chatea con Captain ROCA AI para orientación profesional GRATUITA 24/7, o únete a nuestra lista de espera para mentores especializados.",
    "mentor.chatButton": "Chatear con Captain ROCA AI",
    "mentor.waitlistButton": "Unirse a Lista de Espera",
    "mentor.availableNowBadge": "Disponible Ahora",
    "mentor.dyslexiaFriendly": "Adaptado para Dislexia",
    "mentor.neurodiversityTrained": "Formado en Neurodiversidad",
    "mentor.defaultBio": "Mentor experimentado listo para ayudarte a alcanzar tus objetivos.",
    "mentor.perHour": "/hora",

    // Specialty names
    "specialty.maritime": "Marítimo",
    "specialty.film": "Cine y Entretenimiento",
    "specialty.dyslexiaCoaching": "Coaching de Dislexia",
    "specialty.adhdSupport": "Apoyo TDAH",

    // ROCA Connect - Booking (extended keys)
    "booking.subtitle": "Completa los pasos a continuación para programar tu sesión",
    "booking.step1Title": "1. Elegir Tipo de Sesión",
    "booking.step2Title": "2. Seleccionar Fecha y Hora",
    "booking.step3Title": "3. Definir Tus Objetivos",
    "booking.step4Title": "4. Confirmar Reserva",
    "booking.selectDate": "Seleccionar Fecha",
    "booking.selectTime": "Seleccionar Hora (GMT)",
    "booking.tipMessage": "💡 Consejo: ¡Reserva sesiones durante tus horas de máxima concentración para la mejor experiencia!",
    "booking.goalsPrompt": "¿Qué quieres lograr en esta sesión? (Al menos 1 objetivo requerido)",
    "booking.goal": "Objetivo",
    "booking.required": "(Obligatorio)",
    "booking.goalPlaceholder1": "Entender los requisitos de certificación STCW",
    "booking.goalPlaceholder2": "Obtener retroalimentación sobre mi CV marítimo",
    "booking.goalPlaceholder3": "Conocer oportunidades de trabajo en tripulaciones de yates",
    "booking.sessionDetails": "Detalles de la Sesión",
    "booking.mentor": "Mentor",
    "booking.sessionType": "Tipo de Sesión",
    "booking.duration": "Duración",
    "booking.date": "Fecha",
    "booking.time": "Hora",
    "booking.yourGoals": "Tus Objetivos",
    "booking.costBreakdown": "Desglose de Costos",
    "booking.firstMinsFree": "Primeros 15 minutos",
    "booking.free": "GRATIS",
    "booking.remaining": "Restante",
    "booking.minutes": "minutos",
    "booking.estimatedTotal": "Total Estimado",
    "booking.finalCostNote": "* Costo final basado en la duración real de la sesión",
    "booking.back": "Atrás",
    "booking.next": "Siguiente",
    "booking.confirmBook": "Confirmar y Reservar",
    "booking.booking": "Reservando...",
    "booking.authRequired": "Autenticación requerida",
    "booking.signInPrompt": "Por favor inicia sesión para reservar una sesión",
    "booking.bookingSuccess": "¡Sesión Reservada! 🎉",
    "booking.confirmationEmail": "Revisa tu email para la confirmación y el enlace de la reunión",
    "booking.bookingFailed": "Reserva fallida",
    "booking.tryAgain": "Por favor intenta de nuevo o contacta soporte",
    "booking.mentorNotFound": "Mentor No Encontrado",
    "booking.mentorNotFoundDesc": "El mentor solicitado no pudo ser encontrado.",
    "booking.backToMarketplace": "Volver al Mercado",

    // Session Types
    "session.careerCoaching": "Coaching de Carrera",
    "session.careerCoachingDesc": "Orientación profesional completa y planificación estratégica",
    "session.cvReview": "Revisión de CV",
    "session.cvReviewDesc": "Optimización y retroalimentación profesional de CV",
    "session.certificationGuidance": "Guía de Certificación",
    "session.certificationGuidanceDesc": "Ayuda paso a paso con certificaciones (STCW, etc.)",
    "session.quickQA": "Preguntas Rápidas",
    "session.quickQADesc": "Respuestas rápidas a preguntas específicas",

    // Permis Bateau Objectives
    "permis.objective1": "Objetivo 1: Garantizar la Seguridad Individual",
    "permis.objective2": "Objetivo 2: Garantizar la Seguridad Colectiva",
    "permis.objective3": "Objetivo 3: Equipos de Comunicación",
    "permis.objective4": "Objetivo 4: Toma de Decisiones Meteorológicas",
    "permis.objective5": "Objetivo 5: Reglas de Navegación y Balizamiento",
    "permis.objective6": "Objetivo 6: Responsabilidades del Capitán",
    "permis.objective7": "Objetivo 7: Procedimientos de Emergencia",
    "permis.objective8": "Objetivo 8: Respeto al Medio Ambiente",
    "permis.objective9": "Objetivo 9: Arranque del Motor",
    "permis.objective10": "Objetivo 10: Control de Dirección",
    "permis.objective11": "Objetivo 11: Gestión de Velocidad",
    "permis.objective12": "Objetivo 12: Control de Propulsión",
    "permis.objective13": "Objetivo 13: Maniobra en Reversa",
    "permis.objective14": "Objetivo 14: Uso de Alineaciones",
    "permis.objective15": "Objetivo 15: Maniobras de Atraque",
    "permis.objective16": "Objetivo 16: Boyas de Amarre",
    "permis.objective17": "Objetivo 17: Fondeo",
    "permis.objective18": "Objetivo 18: Recuperación de Hombre al Agua",

    // ROCA Writer

    // ROCA Writer
    "writer.title": "Corrector ROCA",
    "writer.subtitle": "Ortografía y Ajuste de Tono para mentes disléxicas",
    "writer.inputLabel": "Tu Texto",
    "writer.inputPlaceholder": "Pega o escribe tu texto aquí...",
    "writer.selectTone": "Seleccionar tono/contexto",
    "writer.correctAndAdapt": "Corregir y Adaptar",
    "writer.processing": "Procesando...",
    "writer.correctedText": "Texto Corregido",
    "writer.adaptedText": "Texto Adaptado",
    "writer.noText": "Por favor ingresa algún texto",
    "writer.noErrors": "¡Sin errores encontrados! ✓",
    "writer.errorsFound": "errores encontrados",
    "writer.copied": "¡Copiado al portapapeles!",
    "writer.correctionComplete": "¡Corrección completada!",
    "writer.error": "Ocurrió un error. Por favor intenta de nuevo.",

    // Tone contexts
    "tone.professional": "Profesional",
    "tone.friendly": "Amigable",
    "tone.formal": "Formal",
    "tone.interview": "Entrevista de Trabajo",
    "tone.followup": "Seguimiento",
    "tone.boss": "Hablando con el Jefe",
    "tone.family": "Familia",
    "tone.romantic": "Romántico",
    "tone.firstDate": "Primera Cita",
    "tone.castingDirector": "Director de Casting",
    "tone.yachtCaptain": "Capitán de Yate",
    "tone.maritimeInstructor": "Instructor Marítimo",
    "tone.examAnswer": "Respuesta de Examen",

    // Common
    'close': 'Cerrar',
    'download': 'Descargar',
    'view': 'Ver',
    'share': 'Compartir',
    'loading': 'Cargando...',
  }
};

export const useTranslation = (language: Language) => {
  return {
    t: (key: string): string => {
      const keys = key.split('.');
      let value: any = translations[language];
      
      for (const k of keys) {
        value = value?.[k];
      }
      
      return value || key;
    },
    language
  };
};

export const getInitialLanguage = (): Language => {
  // Always default to French on first visit; only honor explicit user choice
  // stored in localStorage. Browser language is intentionally ignored so the
  // site consistently opens in French as the canonical language.
  if (typeof window !== 'undefined') {
    const stored = localStorage.getItem('language') as Language | null;
    if (stored && ['en', 'fr', 'es'].includes(stored)) {
      return stored;
    }
  }
  return 'fr';
};

export const setLanguage = (language: Language) => {
  localStorage.setItem('language', language);
};